import { render, staticRenderFns } from "./AmendmentVisas.vue?vue&type=template&id=22f57682&"
import script from "./AmendmentVisas.vue?vue&type=script&lang=js&"
export * from "./AmendmentVisas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports